<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	props: ['navigations'],
	data() {
		return {
			items: [
				{ header: 'Nom', value: (item) => item.name },
				{
					header: 'valeur',
					value: (item) => {
						if (!this.navigations) {
							return ''
						}
						let data = this.navigations.find((el) => el._id === item._id)
						return data ? data.value : ''
					}
				},
				{
					header: 'dernier passage',
					localFilter: function(searchValue, value, item) {
						return this.$options.filters.formatDate(searchValue) === value
					}.bind(this),
					filter: {
						type: 'date'
					},
					value: (item) => {
						if (!this.navigations) {
							return ''
						}
						let data = this.navigations.find((el) => el._id === item._id)
						if (!data || !data.navigateAt || data.navigateAt.length === 0) {
							return ''
						} else {
							let lastNavigateBegin = new Date(data.navigateAt[0].begin)
							for (let i = 0; i < data.navigateAt.length; i++) {
								if (new Date(data.navigateAt[i].begin).getTime() > lastNavigateBegin.getTime()) {
									lastNavigateBegin = new Date(data.navigateAt[i].begin)
								}
							}
							return this.$options.filters.formatDate(lastNavigateBegin)
						}
					}
				},
				{
					header: 'temps total',
					filter: false,
					sort: false,
					value: (item) => {
						if (!this.navigations) {
							return ''
						}
						let data = this.navigations.find((el) => el._id === item._id)
						if (!data || !data.navigateAt) {
							return ''
						} else {
							let navigateTime = data.navigateAt.reduce((acc, el) => {
								if (el.end) {
									return acc + new Date(el.end).getTime() - new Date(el.begin).getTime()
								}
								return acc
							}, 0)

							let totalSeconde = Math.round(navigateTime / 1000)
							if (totalSeconde > 60) {
								return Math.floor(Math.min(totalSeconde / 60)) + ' min ' + totalSeconde % 60 + 's (en ' + data.navigateAt.length + ' fois)'
							} else {
								return totalSeconde + 's (en ' + data.navigateAt.length + ' fois)'
							}
						}
					}
				},
				{
					header: 'Groupe',
					localFilter(searchValue, value, item) {
						if (searchValue.length === 0) {
							return true
						}
						for (let i = 0; i < searchValue.length; i++) {
							if (item.subBot === searchValue[i]) {
								return true
							}
						}
						return false
					},
					filter: {
						type: 'multi-select',
						values: this.$store.getters.bot.subBots,
						itemText: 'name',
						itemValue: '_id'
					},
					value: (item) => {
						if (item.subBot) {
							return this.$store.getters.bot.subBots.find((el) => el._id === item.subBot).name
						}
						return ''
					},
					cellClick: (item) => {
						if (item.subBot) {
							this.$router.push({ name: 'SubBotDetail', params: { botId: item.bot, subBotId: item.subBot } })
						}
					}
				}
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/users/navigation.list.vue